const schema = {
    // patient_details: {
    //     type: 'heading',
    //     label: 'Patient Details',
    //     required: false,
    //     info: false,
    //     character_count: 0
    // },
    // title: {
    //     type: 'radio',
    //     label: 'Title',
    //     placeholder: 'Choose Title',
    //     options: ['Mr', 'Mrs', 'Miss', 'Ms', 'Mstr', 'Mx', 'Other'],        
    //     required: true,
    //     info: false,
    //     character_count: 0
    // },
    // first_name: {
    //     type: 'text',
    //     label: 'First Name(s)',
    //     placeholder: 'Enter First Name',
    //     required: true,
    //     info: false,
    //     character_count: 0,
    //     wrapper_class: 'col-6'
    // },
    // middle_name: {
    //     type: 'text',
    //     label: 'Middle Name',
    //     placeholder: 'Enter Middle Name',
    //     required: true,
    //     info: false,
    //     character_count: 0,
    //     wrapper_class: 'col-6'
    // },
    // previous_surname: {
    //     type: 'text',
    //     label: 'Previous Surname(s)',
    //     placeholder: 'Enter Previous Surname',
    //     required: true,
    //     info: false,
    //     character_count: 0,
    //     wrapper_class: 'col-6'
    // },
    // last_name: {
    //     type: 'text',
    //     label: 'Last Name',
    //     placeholder: 'Enter Last Name',
    //     required: true,
    //     info: false,
    //     character_count: 0,
    //     wrapper_class: 'col-6'
    // },
    // gender: {
    //     type: 'radio',
    //     label: 'Gender',
    //     placeholder: 'Choose Gender',
    //     options: ['Male', 'Female', 'Other'],        
    //     required: true,
    //     info: false,
    //     character_count: 0
    // },
    // dob: {
    //     type: 'date',
    //     label: 'Date Of Birth',
    //     placeholder: 'Choose DOB',
    //     required: true,
    //     info: false,
    //     character_count: 0,
    //     wrapper_class: 'col-6'
    // },
    // phone_number: {
    //     type: 'number',
    //     label: 'Phone Number',
    //     placeholder: 'Enter Phone Number',
    //     required: true,
    //     info: false,
    //     character_count: 0,
    //     wrapper_class: 'col-6'
    // },
    // email: {
    //     type: 'email',
    //     label: 'Email',
    //     placeholder: 'Enter Email',
    //     required: true,
    //     info: false,
    //     character_count: 0,
    //     wrapper_class: 'col-6'
    // },
    // occupation: {
    //     type: 'text',
    //     label: 'Occupation',
    //     placeholder: 'Enter Occupation',
    //     required: true,
    //     info: false,
    //     character_count: 0,
    //     wrapper_class: 'col-6'
    // },
    // note: {
    //     type: 'paragraph',
    //     label: 'Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum'
    // },
    // message_permission_check: {
    //     type: 'checkbox',
    //     options: ['To opt out of our text message reminder services please tick here.'],        
    //     required: false,
    //     info: false,
    //     character_count: 0
    // },
    // email_permission_check: {
    //     type: 'checkbox',
    //     options: ['To opt out of receiving emails from us, please tick here.'],        
    //     required: false,
    //     info: false,
    //     character_count: 0
    // },
    // patient_details_seperator: {
    //     type: 'seperator',
    // },
    // student: {
    //     type: 'heading',
    //     label: 'Student',
    //     required: false,
    //     info: false,
    //     character_count: 0
    // },
    // student_check: {
    //     type: 'select',
    //     label: 'Are you currently a student?',
    //     options: ['Yes', 'No'],        
    //     required: false,
    //     info: false,
    //     character_count: 0,
    //     wrapper_class: 'col-6'
    // },
    // student_seperator: {
    //     type: 'seperator',
    // },
    // abroad: {
    //     type: 'heading',
    //     label: 'Abroad',
    //     required: false,
    //     info: false,
    //     character_count: 0
    // },
    // abroad_check: {
    //     type: 'select',
    //     label: 'Were you born outside of the U.K.?',
    //     options: ['Yes', 'No'],        
    //     required: false,
    //     info: false,
    //     character_count: 0,
    //     wrapper_class: 'col-6'
    // },
};

const doctorNames = [
    {
        id: 1,
        name: 'Dr. Frank Vickery'
    },
    {
        id: 2,
        name: 'Dr. Robert Winter'
    },
    {
        id: 3,
        name: 'Dr. Crystal Elliott'
    },
    {
        id: 4,
        name: 'Dr. Kristen Steele'
    }
];  

const chatData = [
    {
        id: 1,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Frank Vickery',
        message: 'Hey! there I\'m available',
        time: '04    min',
        status: 'online'
    },
    {
        id: 2,
        image: require('@/assets/images/users/avatar-3.jpg'),
        name: 'Robert Winter',
        message: 'I\'ve finished it! See you so',
        time: '09 min',
        status: 'away'
    },
    {
        id: 3,
        name: 'Crystal Elliott',
        message: 'This theme is awesome!',
        time: '21 min',
        status: 'online'
    },
    {
        id: 4,
        image: require('@/assets/images/users/avatar-4.jpg'),
        name: 'Kristen Steele',
        message: 'Nice to meet you',
        time: '1 hr',
    },
    {
        id: 5,
        name: 'Mitchel Givens',
        message: 'Hey! there I\'m available',
        time: '3 hrs',
        status: 'away'
    },
    {
        id: 6,
        image: require('@/assets/images/users/avatar-6.jpg'),
        name: 'Stephen Hadley',
        message: 'I\'ve finished it! See you so',
        time: '5 hrs',
        status: 'online'
    },
    {
        id: 7,
        image: require('@/assets/images/users/avatar-2.jpg'),
        name: 'Tracy Penley',
        message: 'This theme is awesome!',
        time: '24/03',
        status: 'online'
    },
];  

const chatMessagesData = [
    {
        name: 'Frank Vickery',
        image: require('@/assets/images/users/avatar-2.jpg'),
        message: 'Hello!',
        time: '10:00'
    },
    {
        align: 'right',
        name: 'Henry Wells',
        message: 'Hi, How are you? What about our next meeting?',
        time: '10:02'
    },
    {
        name: 'Frank Vickery',
        image: require('@/assets/images/users/avatar-2.jpg'),
        message: 'Yeah everything is fine',
        time: '10:06'
    },
    {
        name: 'Frank Vickery',
        image: require('@/assets/images/users/avatar-2.jpg'),
        message: '& Next meeting tomorrow 10.00AM',
        time: '10:06'
    },
    {
        align: 'right',
        name: 'Henry Wells',
        message: 'Wow that\'s great',
        time: '10:07'
    }
];

export { schema, doctorNames, chatData, chatMessagesData };